import { useEffect, useState } from "react"
import { transformText } from "../utils/transform";
import TextArea from "./textArea";
import style from "../task-creator.module.css";


export default function EmptyAnswer({id, change, defaultValue}) {
    console.log(defaultValue)
    const [text, setText] = useState('')

  function changeHandler(e) {
    e.target.id === 'text' && setText(e.target.value)
  }

    useEffect(() => {
      if(defaultValue && text==='') {
          let answerText='';
          for (let i = 0; i < defaultValue.length; i++) {
              if (i % 2 !== 0) {
                  answerText += '[?' + defaultValue[i] + '?]'
              } else {
                  answerText += defaultValue[i]
              }
          }
          setText(answerText)
      }
  }, [defaultValue])

  useEffect(() => {
    const answer = transformText(text);
    change(answer, id)
  }, [text])

  return(
    <div className={style.task_line_box}>
      <h2>Ответ</h2>
      <TextArea value={text} id="text" changeHandler={changeHandler} type={6}/>
    </div>
  )
  
}